<template>
	<div>
		<Breadcrumbs main="Device Renewal" title="Add Vehicle Details" />
			<div class="container-fluid">
				<div class="row">
				   	<div class="col-sm-12">
						<div class="card">
							<div class="card-body">
	
								<div class="row mb-3">
									<div class="col-12">
										<a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a>
									</div>
								</div>
	
								<form @submit.prevent="addVehicle" enctype="multipart/form-data">
									<div class="form theme-form">
										<div class="row">
											<div class="col-md-4">
												<div class="mb-3">
													<label class="control-label">IMEI<span class="text-danger">*</span></label>
													<input class="form-control" type="text" placeholder="Enter IMEI" v-model="imei" disabled/>
												</div>
											</div>

											<div class="col-md-4">
												<div class="mb-3">
													<label class="control-label">Vehicle Number<span class="text-danger">*</span></label>
													<input class="form-control" type="text" placeholder="Enter Vehicle Number" v-model="vehicle_no"/>
												</div>
											</div>

											<div class="col-md-4">
												<div class="mb-3">
													<label class="control-label">Engine Number</label>
													<input class="form-control" type="text" placeholder="Enter Engine Number" v-model="engine_no"/>
												</div>
											</div>

											<div class="col-md-4">
												<div class="mb-3">
													<label class="control-label">Chase Number<span class="text-danger">*</span></label>
													<input class="form-control" type="text" placeholder="Enter Chase Number" v-model="chase_no"/>
												</div>
											</div>

											<div class="row">
												<div class="col-md-12">
													<div class="mb-3">
														<label class="control-label">Company <span class="text-danger">*</span></label>
														<!-- Existing customer selection -->
														<template v-if="!isNewCustomer">
															<div class="position-relative">
																<input
																	class="form-control"
																	type="text"
																	placeholder="Search company..."
																	v-model="companySearch"
																	@input="searchCompany"
																	@focus="showCompanySuggestions = true"
																	@blur="hideCompanySuggestions"
																	autocomplete="off"
																/>
																<ul v-if="showCompanySuggestions && filteredCompanies.length"
																	class="list-group position-absolute w-100"
																	style="z-index: 10; max-height: 200px; overflow-y: auto;">
																	<li v-for="company in filteredCompanies"
																		:key="company.id"
																		class="list-group-item list-group-item-action"
																		@mousedown.prevent="selectCompany(company)">
																		{{ company.company_name }} - {{ company.mobile }}
																	</li>
																</ul>
															</div>
															<div v-if="selectedCompany" class="mt-2">
																<small class="text-success">
																	<i class="icofont icofont-check-circled me-1"></i>
																	Selected: <strong>{{ selectedCompany.company_name }} - {{ selectedCompany.mobile }}</strong>
																</small>
															</div>
															<div class="mt-2">
																<a href="#" class="small" @click.prevent="isNewCustomer = true">+ Add new customer</a>
															</div>
														</template>
														<!-- New customer fields - same row -->
														<template v-if="isNewCustomer">
															<div class="row g-2">
																<div class="col-4">
																	<label class="control-label small">Customer Name <span class="text-danger">*</span></label>
																	<input v-model="newCustomer.customer_name" class="form-control form-control-sm" placeholder="Enter customer name" />
																	<span v-if="errors.customer_name" class="text-danger small">{{ errors.customer_name }}</span>
																</div>
																<div class="col-4">
																	<label class="control-label small">Username (Mobile) <span class="text-danger">*</span></label>
																	<input v-model="newCustomer.username" class="form-control form-control-sm" v-mobile-limit placeholder="Enter mobile number" maxlength="10" minlength="10" />
																	<span v-if="errors.username" class="text-danger small">{{ errors.username }}</span>
																</div>
																<div class="col-4">
																	<label class="control-label small">Password <span class="text-danger">*</span></label>
																	<input v-model="newCustomer.password" type="password" class="form-control form-control-sm" placeholder="Enter password" />
																	<span v-if="errors.password" class="text-danger small">{{ errors.password }}</span>
																</div>
															</div>
															<div class="mt-2">
																<a href="#" class="small" @click.prevent="isNewCustomer = false; clearNewCustomerFields()">← Select existing customer</a>
															</div>
														</template>
														<span v-if="errors.company_id" class="text-danger small">{{ errors.company_id }}</span>
													</div>
												</div>
											</div>

										</div>

										<div class="row mt-3">
											<div class="col-sm-12">
												<button class="btn btn-success me-2 float-end" type="submit" :disabled="submitting">
													<span v-if="submitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
													{{ submitting ? "Saving..." : "Save" }}
												</button>
											</div>
										</div>
		
									</div>
								</form>
							</div>
						</div>
				   	</div>
				</div>
			</div>

	</div>
 </template>

<script>
	export default {
		name: "Add Campaign Page",
		

		data() {
			return {
				
				keyword: "",
				showsearch: false,
				listing_length: 10,
				token: "",
				submitting: false,
				errors: {},

				button_title: "Save",

				imei: this.$route.params.imei,
				company_id: "",
				vehicle_no: "",
				engine_no: "",
				chase_no:"",
				complaint_data: "",
				complaint_type: "",

				companies: [],
				companySearch: '',
				showCompanySuggestions: false,
				selectedCompany: null,
				isNewCustomer: false,
				newCustomer: {
					customer_name: '',
					username: '',
					password: ''
				},
			};
		},
		computed: {
			filteredCompanies() {
				if (!this.companySearch.trim()) return this.companies;
				const q = this.companySearch.toLowerCase();
				const seen = new Set();
				return this.companies.filter(c => {
					const name = (c.company_name || '').toLowerCase();
					if (!name.includes(q)) return false;
					if (seen.has(name)) return false;
					seen.add(name);
					return true;
				});
			},
		},
		created() {
			this.fetchCompanies();

		},
		
		methods: {

			getToken() {
				if (localStorage.getItem('airotrack_staff')) {
					var airotrack_staff =  JSON.parse(localStorage.getItem('airotrack_staff')); 
							
					if(airotrack_staff.token) {

						this.token = airotrack_staff.token;
						this.user = airotrack_staff;

					} else {
						this.$swal("", "Failed to fetch token, please login again", "error");
						this.$router.push({ name: "login" });
					}

				} else {
					this.$swal("", "Session expired, please login again", "error");
					this.$router.push({ name: "login" });
				}
			},

            fetchCompanies(page_url = null) {
                let url = "/staffs/companies"; 
                page_url = page_url || url;

                this.getToken();
                this.$axios
                .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
                .then((res) => {
                    var responseData = res.data.data;
                    const arr = Array.isArray(responseData) ? responseData : (responseData?.data || responseData?.companies || []);
                    const seen = new Set();
                    this.companies = arr.filter(c => {
                        const name = (c?.company_name || '').toString().trim().toLowerCase();
                        if (!name || seen.has(name)) return false;
                        seen.add(name);
                        return true;
                    });
                })
                .catch((err) => console.log(err));
            },

			searchCompany() {
				this.showCompanySuggestions = true;
			},
			hideCompanySuggestions() {
				setTimeout(() => { this.showCompanySuggestions = false; }, 200);
			},
			selectCompany(company) {
				this.selectedCompany = company;
				this.company_id = company.id;
				this.companySearch = company.company_name;
				this.showCompanySuggestions = false;
			},

			clearNewCustomerFields() {
				this.newCustomer.customer_name = '';
				this.newCustomer.username = '';
				this.newCustomer.password = '';
			},

			getErrorMessage(message) {
				if (!message) return "Something went wrong";

				if (typeof message === "string") {
					return message;
				}

				if (Array.isArray(message)) {
					for (const item of message) {
						const nestedMessage = this.getErrorMessage(item);
						if (nestedMessage && nestedMessage !== "Something went wrong") {
							return nestedMessage;
						}
					}
					return "Something went wrong";
				}

				if (typeof message === "object") {
					for (const key of Object.keys(message)) {
						const nestedMessage = this.getErrorMessage(message[key]);
						if (nestedMessage && nestedMessage !== "Something went wrong") {
							return nestedMessage;
						}
					}
				}

				return "Something went wrong";
			},

            addVehicle() {
				if (this.submitting) return;

                this.getToken();
                this.errors = {};

				if (this.isNewCustomer) {
					if (!this.newCustomer.customer_name?.trim()) {
						this.errors.customer_name = "Customer name is required";
					}
					if (!this.newCustomer.username?.trim()) {
						this.errors.username = "Username (mobile) is required";
					}
					if (!this.newCustomer.password?.trim()) {
						this.errors.password = "Password is required";
					}
					if (Object.keys(this.errors).length > 0) {
						this.$swal("", "Please fill all new customer fields", "error");
						return;
					}
				} else {
					if (!this.company_id && !this.selectedCompany) {
						this.errors.company_id = "Please select a company";
						this.$swal("", "Please select a company", "error");
						return;
					}
				}

				const submitCompanyId = !this.isNewCustomer ? (this.company_id || this.selectedCompany?.id) : null;
				if (!this.isNewCustomer && !submitCompanyId) {
					this.$swal("", "Please select a company", "error");
					return;
				}

                const config = {
                    headers: {
                        "Content-type": "multipart/form-data",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + this.token,
                    },
                };

                let url = "staffs/addExpiredDeviceVehicle";
                this.submitting = true;

                let formData = new FormData();
                formData.append("imei", this.$route.params.imei);
                formData.append("vehicle_no", this.vehicle_no);
				if (this.isNewCustomer) {
					formData.append("customer_name", this.newCustomer.customer_name.trim());
					formData.append("username", this.newCustomer.username.trim());
					formData.append("password", this.newCustomer.password);
				} else {
					formData.append("company_id", submitCompanyId);
				}
				formData.append("engine_number", this.engine_no);
				formData.append("chassis_number", this.chase_no);

                    this.$axios
                    .post(url, formData, config)
                    .then((response) => {
                        if (response.data.status) {
                            this.$swal("", response.data.message, "success");
                        } else {
                            this.$swal("", response.data.message, "error");
                        }
                        this.clearForm();
                        // this.$router.push({ name: 'expired_devices' })
                        this.$router.go(-1);
                    })
                    .catch((error) => {
                        console.log(error);
                        console.log(error.response);
                        if (error.response) {
                            if (error.response.status == 422) {
								if (error.response.data) {
									const apiMessage = error.response.data.message;
									const errorMessage = this.getErrorMessage(apiMessage);
									this.errors = apiMessage || {};
									this.$swal("", errorMessage, "error");
								}
							} else if (error.response.status == 500) {
								this.$swal("", error.response.statusText, "error");
							} else if (error.response.status == 401) {
								this.$swal("", error.response.statusText, "error");
							} else {
								this.$swal("", "Something went wrong", "error");
							}
                        } else {
                            this.$swal("", "Something went wrong", "error");
                        }
                    })
					.finally(() => {
						this.submitting = false;
					});
            },

            clearForm() {
                this.vehicle_no = "";
                this.company_id = "";
                this.companySearch = "";
                this.selectedCompany = null;
                this.isNewCustomer = false;
                this.clearNewCustomerFields();
                this.errors = {};
            }

		},
	};

</script>